import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'fileInput',
    'uploadButton',
    'selectedFileDisplay',
    'selectedFileName',
    'message',
  ]

  connect() {
    console.log('Internal files controller connected')
  }

  handleFileSelect(event) {
    const file = event.target.files[0]

    if (file) {
      this.selectedFileNameTarget.textContent = file.name
      this.selectedFileDisplayTarget.classList.remove('hidden')
      this.uploadButtonTarget.disabled = false
    }
    else {
      this.selectedFileDisplayTarget.classList.add('hidden')
      this.uploadButtonTarget.disabled = true
    }
  }

  async upload() {
    const file = this.fileInputTarget.files[0]
    if (!file) return

    const formData = new FormData()
    formData.append('file', file)

    this.showMessage(`Uploading ${file.name}...`, 'info')

    try {
      const response = await fetch('/internal/files/upload', {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        },
      })

      const data = await response.json()

      if (response.ok) {
        this.showMessage(`${data.filename} uploaded successfully!`, 'success')

        // Reset input
        this.fileInputTarget.value = ''

        // Reload to show new file
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
      else {
        this.showMessage(`Error: ${data.error}`, 'error')
        this.fileInputTarget.value = ''
      }
    }
    catch (error) {
      this.showMessage(`Upload failed: ${error.message}`, 'error')
      this.fileInputTarget.value = ''
    }
  }

  async delete(event) {
    const button = event.currentTarget // Store reference before async
    const filename = button.dataset.filename

    if (!confirm(`Are you sure you want to delete ${filename}?`)) {
      return
    }

    try {
      const response = await fetch(`/internal/files/${encodeURIComponent(filename)}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      })

      const data = await response.json()

      if (response.ok) {
      // Use the stored button reference
        const row = button.closest('tr')
        row.remove()

        this.showMessage('File deleted successfully', 'success')

        const tbody = document.querySelector('tbody')
        if (tbody && tbody.children.length === 0) {
          window.location.reload()
        }
      }
      else {
        this.showMessage(`Error: ${data.error}`, 'error')
      }
    }
    catch (error) {
      this.showMessage(`Delete failed: ${error.message}`, 'error')
    }
  }

  showMessage(text, type) {
    const colors = {
      success: 'text-green-600 bg-green-50',
      error: 'text-red-600 bg-red-50',
      info: 'text-blue-600 bg-blue-50',
    }

    this.messageTarget.textContent = text
    this.messageTarget.className = `px-4 py-2 rounded ${colors[type] || colors.info}`
    this.messageTarget.classList.remove('hidden')

    if (type === 'success') {
      setTimeout(() => {
        this.messageTarget.classList.add('hidden')
      }, 3000)
    }
  }
}
